import styled from 'styled-components';
import materialUI from '../../material-UI';

export const Loading = styled(materialUI.CircularProgress)``;
